<mat-dialog-content>
  <form [formGroup]="form" class="form-content">
    <div class="py-3">{{ title }}</div>
    <div class="row">
       <mat-form-field class="col-12">
        <mat-label>Jerarquía</mat-label>
        <input matInput type="text" formControlName="hierarchyDescription" />
      </mat-form-field> 

      <mat-form-field class="col-12">
        <mat-label>Código de jerarquía</mat-label>
        <input matInput type="text" formControlName="hierarchyCode" />
      </mat-form-field> 
  
      <mat-form-field class=" col-12 w-100">
        <mat-label>Stock de seguridad</mat-label>
        <input
          matInput
          type="number"
          formControlName="securityStock"
          autocomplete="off"
        />
        <mat-error *ngIf="form.get('securityStock')?.hasError('required')">
          Este campo es obligatorio.
        </mat-error>
        <mat-error *ngIf="form.get('securityStock')?.hasError('min')">
          El valor debe ser mayor a 0.
        </mat-error>
      </mat-form-field>

      
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <div class="mb-2">
    <button mat-stroked-button (click)="closeDialog()">
      <span>Cancelar</span>
    </button>
    <button mat-flat-button class="button-success ms-1" (click)="saveSecurityStock()" [disabled]="!form.valid">
      <span>Guardar</span>
    </button>
  </div>
  <br />
</mat-dialog-actions>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>
